// extracted by mini-css-extract-plugin
export default {"header":"ArticleHeader_header__W008W"};